<template>
  <div class="card" v-bind:class="{covered: covered}" v-on:click="handleClick(index)">
    <img v-bind:src="require(`../assets/${animal}.png`)">
  </div>
</template>

<script>
export default {
  props: ["animal", "covered", "index", "handleClick"]
};
</script>

<style scoped>
.card {
  transition: 0.2s;
  transition: 0.8s;
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  overflow: hidden;
  background: #e3e3e3;
  border-radius: 4px;
}
.card > img {
  transition: 0.8s;
  width: 100%;
}
.card.covered {
  cursor: pointer;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.2) inset;
}
.card.covered:hover {
  background: #bcb0cb;
}
.card.covered > img {
  transform: rotateX(180deg) rotateY(180deg);
  opacity: 0;
}
</style>
